import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { resetAlert } from "@redux/game/gameSlice";
import { useTranslation } from "react-i18next";
import {
	Modal,
	ModalFooterContainer,
	ModalText,
	ModalTitle,
    Image
} from "./GameAlert.style";



const GameAlert = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { maintain, open, title, description } = useSelector(
		(state) => state.game.alert
	);

	const handleClose = () => {
		dispatch(resetAlert());
	};

	return (
		<Modal
			centered
			destroyOnClose
			closable={false}
			width={300}
			open={open}
			onOk={handleClose}
			footer={null}
			okText={t("common.ok")}
		>
			<div style={{ textAlign: "center" }}>
				{maintain && <Image />}
				<ModalTitle>{title}</ModalTitle>
				<ModalText>{description}</ModalText>
			</div>
			<ModalFooterContainer onClick={handleClose}>
				{t("common.ok")}
			</ModalFooterContainer>
		</Modal>
	);
};

export default GameAlert;
